import axios from 'axios';
import {getBrowserType, getUTCDate, getUTCTime, getOS, getDeviceType} from "../utils/systemInfo";
import {logDebug, logError} from "../utils/logger";


// Function to create an Axios instance with a dynamic baseURL
export const createAxiosInstance = (baseURL: string|undefined) => {
    if(!baseURL || (baseURL.includes("http:") && baseURL !== process.env.REACT_APP_DATA_COLLECTOR_SERVER)) {
        baseURL = process.env.REACT_APP_DATA_COLLECTOR_SERVER;
        logDebug('baseURL changed', baseURL);
    }

    return axios.create({
        baseURL: baseURL  // Use the provided baseURL or fallback to getBaseURL
    });
};

// Export the axios instance for use in other services
export default createAxiosInstance;

// Function to set proxy in cookies and fetch client info
export const sendStatistics = async (proxy: string|undefined, client_id:string, user_id: string, client_token:string,
                                     statistics:any, conversation_flag:boolean, message_id:any = 0,endpoint:string="data_collector",
                                     session_id:string|null=null) => {
    const dataCollectorServer = process.env.REACT_APP_DATA_COLLECTOR_API_SERVICE_ENABLED;
    if(dataCollectorServer === "FALSE") return
    logDebug('sendStatistics', statistics);
    const systemInfo = {
        'conversation_time': getUTCTime(),
        'conversation_date': getUTCDate(),
        'conversation_device': getDeviceType(),
        'conversation_browser': getBrowserType(),
        'conversation_os': getOS(),
    };

    session_id = session_id || sessionStorage.getItem("session_ID");
    try {
        const requestData = {
            messages: [{"message_id": message_id,
                        "session_id": session_id,
                        "client_id": client_id,
                        "user_id": user_id,
                        "systemInfo": systemInfo,
                        "statistics": statistics,
                        "content": "sendStatistics sent from FE",
                        "offset_from_utc": new Date().getTimezoneOffset()}]
        };
        logDebug('requestData', requestData);
        // Create a new Axios instance with the updated base URL if needed
        const instance = createAxiosInstance(proxy);

        const response = await instance.post(`/${endpoint}`, requestData, {
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'text/event-stream',
                'Authorization': "Bearer " + client_token
            }
        });

        return response.data;
    } catch (error) {
        logError(`Error sending data to ${endpoint}: `, error);
    }
};
